import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import {
    MessageContent,
    MessageContentGetResponse,
} from '../../models/message-content.model';

import API from '../../services/api';

import messageContentQueryKeys from './_queryKey';

const getMessageContent = async (id: string) => {
    const { data } = await API.fetchMessageContentById(id);
    return data;
};

export default function useMessageContentQuery(id: string) {
    return useQuery<MessageContentGetResponse, BaseError, MessageContent>({
        queryKey: messageContentQueryKeys.messageContent(id),
        queryFn: () => getMessageContent(id),
        enabled: !!id,
        staleTime: 60 * 60 * 2 * 1000, // 2 hours
        select: (data) => ({
            ...data,
            is_labeled_matching_enabled: data.is_label_matching_enabled,
        }),
    });
}
